/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2024
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import Enum from './Enum';
//@import Enum (loadtime) // superclass

/**
 * <p>Java class for metricRoleType. <p>The following schema fragment specifies the expected content contained within this class. <p> <pre> &lt;simpleType name="metricRoleType"&gt; &lt;restriction base="{http://www.w3.org/2001/XMLSchema}NMTOKEN"&gt; &lt;enumeration value="ACTUAL"/&gt; &lt;enumeration value="TIME"/&gt; &lt;enumeration value="TARGET"/&gt; &lt;enumeration value="NONE"/&gt; &lt;/restriction&gt; &lt;/simpleType&gt; </pre>
 */
export default class MetricRoleType extends Enum{

	/**
	 * Applies to queryitem/calculation with usage=fact.
	 */
	static  ACTUAL = MetricRoleType.newLiteral("ACTUAL");

	/**
	 * Applies to queryitem/calculation with usage=attribute and highLevelDataType=date.
	 */
	static  TIME = MetricRoleType.newLiteral("TIME");

	/**
	 * Applies to queryitem/calculation with usage=fact.
	 */
	static  TARGET = MetricRoleType.newLiteral("TARGET");

	/**
	 * Specifies that the object has no specified metric role.
	 */
	static  NONE = MetricRoleType.newLiteral("NONE");



	value() {
		return this.name();
	}

	static fromValue(v) {
		return MetricRoleType.valueOf(v);
	}

	getResourceId() {
		return (("MetricRoleType" + "_") + this.value());
	}
}


// WEBPACK FOOTER //
// ./src/generated/MetricRoleType.js